<template>
  <LayoutDefault isShowFooter customFooter>
    <div class="roles-editor" v-if="dataSource">
      <div class="roles-editor__constructor">

        <div class="roles-editor__header">
          <p class="roles-editor__header-title">
            Настройка полномочий пользователя
          </p>
          <div class="roles-editor__header-line"></div>
        </div>

        <div class="roles-editor__user user">

          <div class="user__item">
            <p class="user__item-title">Фамилия:</p>
            <InputText id="surname" v-model="dataSource.LastName" />
          </div>

          <div class="user__item">
            <p class="user__item-title">Имя:</p>
            <InputText id="username" v-model="dataSource.FirstName" />
          </div>

          <div class="user__item">
            <p class="user__item-title">Отчество:</p>
            <InputText id="patronicName" v-model="dataSource.PatronymicName" />
          </div>

          <div class="user__item">
            <p class="user__item-title">Логин:</p>
            <InputText id="login" v-model="dataSource.UserName" />
          </div>

          <div class="user__item">
            <p class="user__item-title">Пароль:</p>
            <InputText
              id="username"
              v-model="dataSource.Password"
              type="password"
            />
          </div>

          <div class="user__item">
            <p class="user__item-title">Роль:</p>
            <Dropdown
              id="username"
              v-model="dataSource.IsAdmin"
              :options="roles"
              option-label="role"
              option-value="value"
              placeholder="Роль"
            />
          </div>

          <div class="user__btn">
            <button
              :class="{
                'user__button pi': true,
                'pi-lock': !dataSource.IsActive,
                'pi-lock-open': dataSource.IsActive,
              }"
              @click="swichActive"
            />
            <button
              :class="{
                'user__button pi': true,
                'pi-trash': true,
                'disabled': dataSource.Id === 0,
              }"
              :disabled="dataSource.Id === 0"
              @click="switchDeleteModal"
            />
          </div>

        </div>
      </div>
      <div class="roles-editor__projects projects">
        <div class="roles-editor__header">
          <p class="roles-editor__header-title">
            Проекты
          </p>
          <div class="roles-editor__header-line"></div>
          <CloseIcon @click="goToTable"/>
        </div>
        <RolesEditorProjects/>
      </div>

      <!-- <div class="roles-editor__controllers controllers">
        <div class="controllers__top">
          <CloseIcon @click="goToTable"/>
          <IndicatorDate
            name="История изменений"
            mark
            date="06.06.23"
            @click-icon="getUserActions"
          />
        </div>
        <div class="controllers__buttons">
          <SaveCancelButtons
            @click-save="saveUser"
            :disabled-save="checkChange"
          />
        </div>
      </div> -->

    </div>

    <template #customFooter>
      <div class="buttons">
        <BaseBtnNew
          name="Сохранить"
          @clickBtn="saveUser"
          :disabled="checkChange"
        >
          <SaveIconNew/>
        </BaseBtnNew>
        <BaseBtnNew
          red
          name="Отменить"
          @clickBtn="goToTable"
        >
        <CancelIcon/>
        </BaseBtnNew>
      </div>
    </template>

    <MiniModal
      v-if="deleteModal"
      first-button-text="Да"
      :close-modal="switchDeleteModal"
      @click-save="deleteUser"
    >
      <h2>Удалить данного пользователя ?</h2>
    </MiniModal>

    <Transition name="bounce">

      <BaseModalWindow
        v-if="showStoryChangeUser"
        @close-modal="switchStoryChangeUser"
        title="История изменений"
      >
        <StoryChangeUser
          :data="userActions"
        />
      </BaseModalWindow>
    </Transition>

  </LayoutDefault>
</template>

<script>
import { computed, ref, onBeforeMount } from 'vue'
import { useStore } from 'vuex'
import router from '@/router'
import { useRoute } from 'vue-router'

import LayoutDefault from '@/layout/LayoutDefault.vue'
import RolesEditorProjects from '@/components/blocks/RolesEditorProjects.vue'
import CloseIcon from '@/components/icons/CloseIcon.vue'
// import SaveCancelButtons from '@/components/elements/SaveCancelButtons.vue'
import MiniModal from '@/components/modals/MiniModal.vue'
// import IndicatorDate from '@/components/ui/IndicatorDate.vue'
import BaseModalWindow from '@/components/modals/BaseModalWindow.vue'

import InputText from 'primevue/inputtext'
import Dropdown from 'primevue/dropdown'
import StoryChangeUser from '@/components/modals/StoryChangeUser.vue'
import BaseBtnNew from '@/components/ui/BaseBtnNew'
import CancelIcon from '@/components/icons/CancelIcon.vue'
import SaveIconNew from '@/components/icons/SaveIconNew.vue'

export default {
  name: 'RolesEditorView',
  components: {
    LayoutDefault,
    InputText,
    RolesEditorProjects,
    CloseIcon,
    // SaveCancelButtons,
    Dropdown,
    MiniModal,
    // IndicatorDate,
    BaseModalWindow,
    StoryChangeUser,
    BaseBtnNew,
    CancelIcon,
    SaveIconNew
  },
  setup () {
    const store = useStore()
    const route = useRoute()

    onBeforeMount(() => {
      store.dispatch('setGetUserForm', route.params.id)
    })

    const roles = ref([
      {
        value: true,
        role: 'Администратор'
      },
      {
        value: false,
        role: 'Пользователь'
      }
    ])

    const deleteModal = ref(false)

    const switchDeleteModal = () => {
      deleteModal.value = !deleteModal.value
    }

    const dataSource = computed(() => store.getters.getUserForm)
    const dataOrigin = computed(() => store.getters.getOriginUserForm)

    const checkChange = computed(() => {
      return JSON.stringify(dataSource.value) === JSON.stringify(dataOrigin.value)
    })

    const goToTable = () => {
      router.push('/roles')
    }

    const swichActive = () => {
      dataSource.value.IsActive = !dataSource.value.IsActive
    }

    const saveUser = async () => {
      await store.dispatch('setPutUserForm', dataSource.value)
      store.dispatch('setGetUserForm', dataSource.value.Id)
    }

    const deleteUser = () => {
      store.dispatch('setDeleteUser', dataSource.value.Id)
      goToTable()
    }

    const showStoryChangeUser = ref(false)

    const switchStoryChangeUser = () => {
      showStoryChangeUser.value = !showStoryChangeUser.value
    }

    const getUserActions = () => {
      store.dispatch('setUserActions', dataSource.value.Id)
      switchStoryChangeUser()
    }

    const userActions = computed(() => store.getters.getUserActions)

    return {
      dataSource,
      goToTable,
      swichActive,
      saveUser,
      deleteUser,
      checkChange,
      roles,
      switchDeleteModal,
      deleteModal,
      showStoryChangeUser,
      switchStoryChangeUser,
      getUserActions,
      userActions
    }
  }
}
</script>

<style lang="scss" scoped>
.roles-editor {
  position: relative;
  display: flex;
  width: 100%;

  &__header {
    display: flex;
    gap: 12px;
    align-items: center;
    margin-bottom: 12px;

    &-title {
      font-size: 18px;
      font-weight: 700;
      line-height: 22px;
    }

    &-line {
      display: block;
      flex: 1;
      height: 2px;
      background-color: #C8C8C8;
    }
  }

  &__constructor {
    width: 50%;
    padding-right: 24px;
    padding-bottom: 24px;
    height: calc(100vh - 115px);
    overflow: auto;
    border-right: 2px solid #C8C8C8;
  }

  &__projects {
    width: 50%;
    padding-left: 24px;
    padding-bottom: 24px;
    height: calc(100vh - 115px);
    overflow: auto;
  }

  &__title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
    margin-bottom: 25px;
    color: #000000;
    font-size: 26px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.52px;
  }

  &__user, .user {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;

    &__button {
      @include flex-center;
      width: 40px;
      height: 40px;
      border-radius: 4px;
      border: 1px solid #ced4da;
      background-color: #FFFFFF;

      @media(any-hover: hover) {
        &:hover {
          border-color: #1BA6DA;
        }
      }

    }

    &__item {
      display: flex;
      flex-direction: column;
      gap: 8px;
      width: 100%;

      &-title {
        color: #000000;
        font-weight: 500;
        font-size: 18px;
        text-align: left;
      }
    }

    &__btn {
      display: flex;
      gap: 8px;
    }
  }

  &__controllers, .controllers {
    position: relative;
    width: 280px;
    height: calc(100vh - 25px);

    &__top {
      position: fixed;
      right: 40px;
      top: 32px;
      display: flex;
      flex-direction: column;
      gap: 30px;
      align-items: flex-end;
    }

    &__buttons {
      display: flex;
      gap: 12px;
      justify-content: flex-end;
      :deep(.base-button) {
        width: 200px;
      }
    }
  }
}

:deep(.footer) {
  justify-content: flex-end !important;
}
.p-dropdown {
  width: 100%;
  height: 39px;
  text-align: start;
}

.p-inputtext:enabled:hover {
  border-color: #1ba6da;
}

.p-inputtext:enabled:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.1rem #a6d5fa;
  border-color: #1ba6da;
  -webkit-box-shadow: inset 0 0 0 50px white;
}

.pi {
  &-lock {
    color: #E31E24;
    transition: 1s;

    &-open {
      color: #00CB2D;
      transition: 1s;
    }
  }

  &-trash {
    color: #000000;
  }
}

.disabled {
  opacity: 0.7;
  color: #CCCCCC;
}

.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}

.buttons {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  :deep(.base-button) {
    width: 200px;
  }
}

:deep(.p-dropdown:hover) {
  border-color: #00ABEC !important;
}
.p-dropdown {
  background-color: #F5F5F5;
  border: 1px solid #C8C8C8;
  border-radius: 6px;
  text-align: left;

  height: 42px;
  padding: 5px;
}
.p-disabled {
  opacity: 0.5;
}
:deep(.p-dropdown) {
  &.p-focus {
    box-shadow: none !important;
    outline: none; /* опционально: убрать outline, если тоже мешает */
  }

  &:focus-visible {
    box-shadow: none !important;
    outline: none;
  }
}
:deep(.base-button) {
  width: 200px;
}
:deep(.footer) {
  justify-content: flex-end !important;
}
.p-inputwrapper-filled {
  //color: #000000 !important;
  &:hover {
    //background-color: #0080B1 !important;
    //color: #FFFFFF !important;
    //fill: #FFFFFF !important;
  }
}
:deep(.p-dropdown) {
  &.p-inputwrapper-filled {
    .p-dropdown-clear-icon,
    .p-dropdown-trigger,
    .p-dropdown-label,
    .p-dropdown-item .p-checkbox .p-checkbox-box,
    .p-dropdown-item .p-checkbox .p-checkbox-icon {
      &:hover {
        //color: #FFFFFF !important;
      }
    }
  }
}

:deep(.p-inputtext) {
  border: 1px solid #000000;
  width: 100% !important;
  // -webkit-box-shadow: inset 0 0 0 50px white;
}

:deep(.p-inputtext:enabled:hover) {
  border-color: #00ABEC;
}
:deep(.p-inputtext:disabled) {
  opacity: 0.5;
}

:deep(.p-inputtext:enabled:focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.1rem #00ABEC;
  border-color: #00ABEC;
  -webkit-box-shadow: inset 0 0 0 50px white;
}
</style>
